import React, { useEffect, useState } from "react";
import "./css/entry.css";
import "./css/reports.css";
////
import { useLocation } from "react-router-dom";
import moment from "moment";
import TokenService from "./service/TokenService";
import { Box, Typography } from "@mui/material";
import apiClient from "./BaseUrl/apiClient";
import dayjs from "dayjs";
import { Stack } from "react-bootstrap";
//import EncryptService from "./service/EncryptionService";

function Reports() {
  //const navigate = useNavigate();
  const { state } = useLocation();
  let indentId = state.po_id;
  const [reportPOdata, setreportPOdata] = useState([]);
  const [reportMaterialdata, setreportMaterialdata] = useState([]);
  const [reportSuitable, setreportSuitable] = useState([]);
  const [reportBillDetails, setreportBillDetails] = useState([]);
  const [reportBillPassing, setreportBillPassing] = useState([]);
  const [dpExtend, setdpExtend] = useState([]);
  const [reportCRN, setreportCRN] = useState([]);
  const [reportPayment, setreportPayment] = useState([]);
  const [consigneeTPI, setconsigneeTPI] = useState("");
  //let dpDate = dayjs();
  const [olddpDate, setolddpDate] = useState(dayjs());

  //  </div>
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  //const uname = sessionStorage.getItem("token");

  ////////////////PO Details///////////////////////
  const getPOData = async (e) => {
if (!indentId || indentId.trim() === "") return;

    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "0",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportPOdata(response11.data);
        setolddpDate(reportPOdata[0]?.DPDate);
        // console.log();
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };
  ////////////////Materials Details///////////////////////
  const getMaterialData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "1",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportMaterialdata(response11.data);
        setconsigneeTPI(response11?.data[0]?.tpidonetype);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////Suityalility Details///////////////////////
  const getSuityalilityData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "2",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportSuitable(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////Bill Details///////////////////////
  const getBillData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "3",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportBillDetails(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };
  ////////////////Bill Passing///////////////////////
  const getBillPassingData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "4",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportBillPassing(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////CRN Details///////////////////////
  const getCRNData = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "5",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportCRN(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////CRN Details///////////////////////
  const getPaymentDetails = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "6",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setreportPayment(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  ////////////////DP Extend Details///////////////////////
  const getDPExtendDetails = async (e) => {
    if (!indentId || indentId.trim() === "") return;
    try {
      const response11 = await apiClient.post("/poDataReports", {
        vponumber: indentId.toString(),
        vreporttype: "7",
        vuname: uname,
      });
      if (response11.data && response11.data.length > 0) {
        setdpExtend(response11.data);
        // console.log(response11.data);
      } else {
        // Throw an error if no data is found
      }
    } catch (error) {
      // Handle and set the error in state
    }
  };

  useEffect(() => {
    getPaymentDetails();
    getCRNData();
    getSuityalilityData();
    getBillPassingData();
    getBillData();
    getPOData();
    getMaterialData();
    getDPExtendDetails();
  }, []);
  //olddpDate,getBillData,getBillPassingData,getCRNData,getMaterialData,getPOData,getPaymentDetails,getSuityalilityData
  function formatDate(inputDate) {
    if (inputDate) {
      const date = moment(inputDate);

      // Check if the date is valid
      if (date.isValid()) {
        // Return the formatted date
        return date.format("DD-MMM-YYYY");
      } else {
        // Return null if the date is invalid
        return "";
      }
    } else {
      return "";
    }
  }

  return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      background: "#f5f9ff",
      p: {
        xs: 0.8,
        sm: 1.2,
        md: 1.8,
      },
    }}
  >
    {/* =====================================================
        MAIN REPORT CARD
    ====================================================== */}
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        background: "#ffffff",
        borderRadius: {
          xs: 2,
          sm: 2.5,
          md: 3,
        },
        border: "1px solid #d9e4f1",
        boxShadow: "0 6px 24px rgba(13,71,161,0.08)",
        overflow: "hidden",
      }}
    >
      {/* ===================================================
          WATERMARK
      ==================================================== */}
      {reportPOdata[0]?.pocancellationstatus && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            zIndex: 20,
            overflow: "hidden",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "3rem",
                sm: "5rem",
                md: "7rem",
              },
              fontWeight: 900,
              color: "rgba(211,47,47,0.10)",
              transform: "rotate(-30deg)",
              whiteSpace: "nowrap",
              userSelect: "none",
            }}
          >
            PO CANCELED
          </Typography>
        </Box>
      )}

      {/* ===================================================
          REPORT HEADER
      ==================================================== */}
      <Box
        sx={{
          position: "relative",
          px: {
            xs: 1.5,
            sm: 2.5,
            md: 3,
          },
          py: {
            xs: 1.6,
            sm: 2,
            md: 2.4,
          },
          color: "#fff",
          background:
            "linear-gradient(135deg,#0d47a1 0%,#1565c0 48%,#1976d2 100%)",
          overflow: "hidden",

          "&::after": {
            content: '""',
            position: "absolute",
            width: {
              xs: 120,
              sm: 180,
              md: 240,
            },
            height: {
              xs: 120,
              sm: 180,
              md: 240,
            },
            right: {
              xs: -55,
              sm: -70,
              md: -90,
            },
            top: {
              xs: -65,
              sm: -90,
              md: -120,
            },
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 1,
            sm: 1.5,
          }}
          sx={{
            position: "relative",
            zIndex: 1,
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              width: {
                xs: 42,
                sm: 48,
                md: 52,
              },
              height: {
                xs: 42,
                sm: 48,
                md: 52,
              },
              minWidth: {
                xs: 42,
                sm: 48,
                md: 52,
              },
              borderRadius: {
                xs: 1.8,
                sm: 2.2,
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.16)",
              border: "1px solid rgba(255,255,255,0.25)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: {
                  xs: "1.1rem",
                  sm: "1.3rem",
                  md: "1.45rem",
                },
              }}
            >
              PO
            </Typography>
          </Box>

          <Box
            sx={{
              minWidth: 0,
              flex: 1,
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: {
                  xs: "1rem",
                  sm: "1.2rem",
                  md: "1.4rem",
                },
                lineHeight: 1.25,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              Purchase Order Report
            </Typography>

            <Typography
              sx={{
                mt: 0.35,
                fontSize: {
                  xs: "0.68rem",
                  sm: "0.78rem",
                  md: "0.85rem",
                },
                opacity: 0.88,
              }}
            >
              Complete PO lifecycle and transaction details
            </Typography>
          </Box>
        </Stack>
      </Box>

      {/* ===================================================
          REPORT CONTENT
      ==================================================== */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          p: {
            xs: 1.2,
            sm: 1.8,
            md: 2.5,
          },
        }}
      >
        {/* =================================================
            ORGANISATION HEADER
        ================================================== */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            textAlign: "center",
            mb: {
              xs: 1.2,
              sm: 1.8,
              md: 2,
            },
            pb: 1,
            borderBottom: "2px solid #1565c0",
          }}
        >
          <Typography
            sx={{
              color: "#0d47a1",
              fontWeight: 900,
              fontSize: {
                xs: "0.95rem",
                sm: "1.15rem",
                md: "1.35rem",
              },
              lineHeight: 1.3,
              overflowWrap: "anywhere",
            }}
          >
            Mechanical Workshop, NER, Gorakhpur
          </Typography>
        </Box>

        {/* =================================================
            INDENT / PO SUMMARY
        ================================================== */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            p: {
              xs: 1.1,
              sm: 1.5,
              md: 1.8,
            },
            mb: 1.5,
            borderRadius: 2,
            border: "1px solid #d9e5f2",
            background:
              "linear-gradient(135deg,#f4f8ff 0%,#ffffff 100%)",
            boxShadow:
              "0 2px 8px rgba(13,71,161,0.04)",
          }}
        >
          <Typography
            sx={{
              fontWeight: 900,
              color: "#1565c0",
              fontSize: {
                xs: "0.82rem",
                sm: "0.9rem",
                md: "0.98rem",
              },
              mb: 0.8,
            }}
          >
            Indent Details
          </Typography>

          {reportPOdata[0]?.IndentDetails
            ?.split("\n\n")
            .map((line, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: {
                    xs: "0.72rem",
                    sm: "0.78rem",
                    md: "0.84rem",
                  },
                  color: "#37474f",
                  lineHeight: 1.5,
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                  mb: 0.25,
                }}
              >
                {line}
              </Typography>
            ))}

          <Box
            sx={{
              mt: 1.2,
              pt: 1,
              borderTop: "1px dashed #b9cbe0",
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
              },
              gap: 1,
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "0.75rem",
                  sm: "0.82rem",
                },
                fontWeight: 700,
                overflowWrap: "anywhere",
              }}
            >
              <Box
                component="span"
                sx={{ color: "#1565c0" }}
              >
                PO Number:
              </Box>{" "}
              {indentId || "N/A"}
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "0.75rem",
                  sm: "0.82rem",
                },
                fontWeight: 700,
                overflowWrap: "anywhere",
              }}
            >
              <Box
                component="span"
                sx={{ color: "#1565c0" }}
              >
                PO Date:
              </Box>{" "}
              {formatDate(
                reportPOdata[0]?.PODate
              ) || "N/A"}
            </Typography>
          </Box>
        </Box>

        {/* =================================================
            PO DETAILS HEADER
        ================================================== */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            mb: 1,
            px: {
              xs: 1.2,
              sm: 1.5,
              md: 1.8,
            },
            py: {
              xs: 0.9,
              sm: 1,
            },
            borderRadius: 1.8,
            color: "#fff",
            background:
              "linear-gradient(135deg,#0d47a1,#1565c0)",
            fontWeight: 800,
            fontSize: {
              xs: "0.76rem",
              sm: "0.84rem",
              md: "0.92rem",
            },
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          PO Details — PO Type{" "}
          {reportPOdata[0]?.potype_description || "N/A"}
          {", DP Extension "}
          {reportPOdata[0]?.dpextension || "0"} Times
        </Box>

        {/* =================================================
            GEM INFORMATION
        ================================================== */}
        {reportPOdata[0]?.gemtype !== 0 && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              mb: 1,
              p: {
                xs: 1,
                sm: 1.2,
              },
              borderRadius: 1.8,
              background: "#eef6ff",
              border: "1px solid #c9def5",
              color: "#0d47a1",
              fontSize: {
                xs: "0.74rem",
                sm: "0.82rem",
              },
              fontWeight: 700,
              overflowWrap: "anywhere",
            }}
          >
            GeM Number:{" "}
            {reportPOdata[0]?.gemno || "N/A"}{" "}
            | GeM Date:{" "}
            {formatDate(reportPOdata[0]?.gemdate) ||
              "N/A"}
          </Box>
        )}

        {/* =================================================
            CANCELLATION STATUS
        ================================================== */}
        {reportPOdata[0]?.pocancellationstatus ? (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              mb: 1.5,
              p: {
                xs: 1,
                sm: 1.3,
              },
              borderRadius: 1.8,
              border: "1px solid #ffcdd2",
              background: "#fff5f5",
              color: "#b71c1c",
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: {
                  xs: "0.78rem",
                  sm: "0.86rem",
                },
                overflowWrap: "anywhere",
              }}
            >
              PO Status:{" "}
              {reportPOdata[0]?.pocancellationstatus}
            </Typography>

            <Typography
              sx={{
                mt: 0.35,
                fontSize: {
                  xs: "0.72rem",
                  sm: "0.8rem",
                },
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              Reason:{" "}
              {reportPOdata[0]?.cancleresion || "N/A"}
            </Typography>
          </Box>
        ) : null}

        {/* =================================================
            GENERIC SECTION HELPER STYLE
        ================================================== */}

        {/* =================================================
            PO BASIC INFORMATION
        ================================================== */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            p: {
              xs: 1,
              sm: 1.3,
              md: 1.5,
            },
            border: "1px solid #d9e5f2",
            borderRadius: 2,
            background: "#fff",
            mb: 1.8,
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                md: "repeat(3, minmax(0, 1fr))",
              },
              gap: {
                xs: 0.8,
                sm: 1,
                md: 1.2,
              },
              minWidth: 0,
            }}
          >
            {[
              [
                "Consignee",
                `${reportPOdata[0]?.Shop || "N/A"} (${reportPOdata[0]?.POConsignee || "N/A"})`,
              ],
              [
                "Supplier",
                reportPOdata[0]?.party_name || "N/A",
              ],
              [
                "PO Quantity",
                `${reportPOdata[0]?.POQty || "N/A"} ${reportPOdata[0]?.unit || ""}`,
              ],
              [
                "PO Value",
                reportPOdata[0]?.POValue || "N/A",
              ],
              [
                "DP Date",
                formatDate(reportPOdata[0]?.DPDate) ||
                  "N/A",
              ],
            ].map(([label, value], index) => (
              <Box
                key={index}
                sx={{
                  minWidth: 0,
                  p: {
                    xs: 0.8,
                    sm: 1,
                  },
                  borderRadius: 1.5,
                  background: "#f7faff",
                  border: "1px solid #e6edf6",
                }}
              >
                <Typography
                  sx={{
                    color: "#1565c0",
                    fontWeight: 800,
                    fontSize: {
                      xs: "0.68rem",
                      sm: "0.74rem",
                    },
                  }}
                >
                  {label}
                </Typography>

                <Typography
                  sx={{
                    mt: 0.25,
                    color: "#263238",
                    fontWeight: 600,
                    fontSize: {
                      xs: "0.72rem",
                      sm: "0.8rem",
                    },
                    lineHeight: 1.4,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                  }}
                >
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* =================================================
            DP EXTENSION
        ================================================== */}
        {dpExtend && dpExtend.length > 0 && (
          <Box sx={{ mb: 1.8 }}>
            <Box
              sx={{
                px: 1.4,
                py: 0.9,
                mb: 1,
                borderRadius: 1.8,
                background:
                  "linear-gradient(135deg,#0d47a1,#1976d2)",
                color: "#fff",
                fontWeight: 800,
                fontSize: {
                  xs: "0.76rem",
                  sm: "0.84rem",
                },
              }}
            >
              DP Extension Details
            </Box>

            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                p: 1,
                border: "1px solid #d9e5f2",
                borderRadius: 2,
              }}
            >
              {dpExtend.map((item, index) => (
                <Box
                  key={item.id || index}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, minmax(0,1fr))",
                      md: "repeat(3, minmax(0,1fr))",
                    },
                    gap: 1,
                    py: 0.8,
                    borderBottom:
                      index < dpExtend.length - 1
                        ? "1px dashed #cbd8e6"
                        : "none",
                  }}
                >
                  {[
                    [
                      "Extension Number",
                      item.extensionnumber || "N/A",
                    ],
                    [
                      "OLD Date",
                      formatDate(item.olddpdate) ||
                        "N/A",
                    ],
                    [
                      "New Date",
                      formatDate(item.newdpdate) ||
                        "N/A",
                    ],
                    [
                      "MA Number",
                      item.manumber || "N/A",
                    ],
                    [
                      "MA Date",
                      formatDate(item.madate) ||
                        "N/A",
                    ],
                  ].map(([label, value], i) => (
                    <Box key={i} sx={{ minWidth: 0 }}>
                      <Typography
                        component="span"
                        sx={{
                          color: "#1565c0",
                          fontWeight: 800,
                          fontSize: "0.7rem",
                        }}
                      >
                        {label}:{" "}
                      </Typography>

                      <Typography
                        component="span"
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                        }}
                      >
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* =================================================
            MATERIAL RECEIVING
        ================================================== */}
        {reportMaterialdata &&
          reportMaterialdata.length > 0 && (
            <Box sx={{ mb: 1.8 }}>
              <Box
                sx={{
                  px: 1.4,
                  py: 0.9,
                  mb: 1,
                  borderRadius: 1.8,
                  background:
                    "linear-gradient(135deg,#0d47a1,#1976d2)",
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: {
                    xs: "0.76rem",
                    sm: "0.84rem",
                  },
                }}
              >
                Materials Receiving Details
              </Box>

              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  p: {
                    xs: 0.8,
                    sm: 1.2,
                  },
                  border: "1px solid #d9e5f2",
                  borderRadius: 2,
                }}
              >
                {reportMaterialdata.map((item, index) => (
                  <Box
                    key={item.id || index}
                    sx={{
                      py: 1,
                      borderBottom:
                        index <
                        reportMaterialdata.length - 1
                          ? "1px dashed #cbd8e6"
                          : "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "repeat(2, minmax(0,1fr))",
                          md: "repeat(3, minmax(0,1fr))",
                        },
                        gap: 1,
                        minWidth: 0,
                      }}
                    >
                      {[
                        [
                          "Gate Pass Number",
                          item.getpassnumber || "N/A",
                        ],
                        [
                          "Receiving Date",
                          formatDate(
                            item.itemReceivedDate
                          ) || "N/A",
                        ],
                        [
                          "Quantity",
                          `${item.receivedItemQty || "N/A"} (${item.itemrecicingtype || "N/A"})`,
                        ],
                        [
                          "Value",
                          item.receivedItemValue || "N/A",
                        ],
                        [
                          "Inspection Type",
                          item.tpidonetype || "N/A",
                        ],
                        ...(item.tpidonetype !==
                        "Consignee"
                          ? [
                              [
                                "TPI Agency",
                                item.tpiagency || "N/A",
                              ],
                              [
                                "TPI Date",
                                formatDate(
                                  item.tpidate
                                ) || "N/A",
                              ],
                            ]
                          : []),
                      ].map(([label, value], i) => (
                        <Box
                          key={i}
                          sx={{
                            minWidth: 0,
                            p: 0.8,
                            borderRadius: 1.3,
                            background: "#f8fbff",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#1565c0",
                              fontWeight: 800,
                              fontSize: "0.68rem",
                            }}
                          >
                            {label}
                          </Typography>

                          <Typography
                            sx={{
                              mt: 0.2,
                              fontSize: "0.74rem",
                              fontWeight: 600,
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            }}
                          >
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}

        {/* =================================================
            SUITABILITY
        ================================================== */}
        {consigneeTPI === "Consignee" &&
          reportSuitable &&
          reportSuitable.length > 0 && (
            <Box sx={{ mb: 1.8 }}>
              <Box
                sx={{
                  px: 1.4,
                  py: 0.9,
                  mb: 1,
                  borderRadius: 1.8,
                  background:
                    "linear-gradient(135deg,#0d47a1,#1976d2)",
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: {
                    xs: "0.76rem",
                    sm: "0.84rem",
                  },
                }}
              >
                Suitability Details
              </Box>

              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  p: {
                    xs: 0.8,
                    sm: 1.2,
                  },
                  border: "1px solid #d9e5f2",
                  borderRadius: 2,
                }}
              >
                {reportSuitable.map((item, index) => (
                  <Box
                    key={item.id || index}
                    sx={{
                      py: 1,
                      borderBottom:
                        index < reportSuitable.length - 1
                          ? "1px dashed #cbd8e6"
                          : "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "repeat(2, minmax(0,1fr))",
                          md: "repeat(4, minmax(0,1fr))",
                        },
                        gap: 1,
                        minWidth: 0,
                      }}
                    >
                      {[
                        [
                          "Gate Pass Number",
                          item.getpassnumber || "N/A",
                        ],
                        [
                          "Received Qty.",
                          item.receivedItemQty || "N/A",
                        ],
                        [
                          "Suitable Qty.",
                          item.SuitabilityQty || "N/A",
                        ],
                        [
                          "Suitability Date",
                          formatDate(
                            item.SuitabilityDate
                          ) || "N/A",
                        ],
                        [
                          "Memo Date",
                          formatDate(item.memodate) ||
                            "N/A",
                        ],
                        [
                          "Suitability Type",
                          item.SuitabilityDescriptaion ||
                            "N/A",
                        ],
                        ...(item.SuitabilityDescriptaion !==
                        "Item Suitable"
                          ? [
                              [
                                "Reason",
                                item.reason || "N/A",
                              ],
                            ]
                          : []),
                      ].map(([label, value], i) => (
                        <Box key={i} sx={{ minWidth: 0 }}>
                          <Typography
                            sx={{
                              color: "#1565c0",
                              fontWeight: 800,
                              fontSize: "0.68rem",
                            }}
                          >
                            {label}
                          </Typography>

                          <Typography
                            sx={{
                              mt: 0.2,
                              fontSize: "0.74rem",
                              fontWeight:
                                label === "Suitable Qty." ||
                                label ===
                                  "Suitability Type"
                                  ? 800
                                  : 600,
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            }}
                          >
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}

        {/* =================================================
            BILL DETAILS
        ================================================== */}
        {reportBillDetails &&
          reportBillDetails.length > 0 && (
            <Box sx={{ mb: 1.8 }}>
              <Box
                sx={{
                  px: 1.4,
                  py: 0.9,
                  mb: 1,
                  borderRadius: 1.8,
                  background:
                    "linear-gradient(135deg,#0d47a1,#1976d2)",
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: {
                    xs: "0.76rem",
                    sm: "0.84rem",
                  },
                }}
              >
                Bill Details
              </Box>

              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  p: {
                    xs: 0.8,
                    sm: 1.2,
                  },
                  border: "1px solid #d9e5f2",
                  borderRadius: 2,
                }}
              >
                {reportBillDetails.map((item, index) => (
                  <Box
                    key={item.id || index}
                    sx={{
                      py: 1,
                      borderBottom:
                        index <
                        reportBillDetails.length - 1
                          ? "1px dashed #cbd8e6"
                          : "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "repeat(2, minmax(0,1fr))",
                          md: "repeat(3, minmax(0,1fr))",
                        },
                        gap: 1,
                      }}
                    >
                      {[
                        [
                          "Bill Number",
                          item.billnumber || "N/A",
                        ],
                        [
                          "Bill Date",
                          formatDate(item.billdate) ||
                            "N/A",
                        ],
                        [
                          "Bill Receiving Date",
                          formatDate(
                            item.billreceiptdate
                          ) || "N/A",
                        ],
                        [
                          "Quantity",
                          item.billitemQty || "N/A",
                        ],
                        [
                          "Value",
                          item.billitemValue || "N/A",
                        ],
                        [
                          "Bill Type",
                          item.pmnttype || "N/A",
                        ],
                      ].map(([label, value], i) => (
                        <Box
                          key={i}
                          sx={{
                            minWidth: 0,
                            p: 0.8,
                            background: "#f8fbff",
                            borderRadius: 1.3,
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#1565c0",
                              fontWeight: 800,
                              fontSize: "0.68rem",
                            }}
                          >
                            {label}
                          </Typography>

                          <Typography
                            sx={{
                              mt: 0.2,
                              fontSize: "0.74rem",
                              fontWeight:
                                label === "Bill Number"
                                  ? 800
                                  : 600,
                              overflowWrap: "anywhere",
                            }}
                          >
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}

        {/* =================================================
            BILL PASSING
        ================================================== */}
        {reportBillPassing &&
          reportBillPassing.length > 0 && (
            <Box sx={{ mb: 1.8 }}>
              <Box
                sx={{
                  px: 1.4,
                  py: 0.9,
                  mb: 1,
                  borderRadius: 1.8,
                  background:
                    "linear-gradient(135deg,#0d47a1,#1976d2)",
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: {
                    xs: "0.76rem",
                    sm: "0.84rem",
                  },
                }}
              >
                Bill Passing Details
              </Box>

              <Box
                sx={{
                  width: "100%",
                  minWidth: 0,
                  p: {
                    xs: 0.8,
                    sm: 1.2,
                  },
                  border: "1px solid #d9e5f2",
                  borderRadius: 2,
                }}
              >
                {reportBillPassing.map((item, index) => (
                  <Box
                    key={item.id || index}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0,1fr))",
                        md: "repeat(3, minmax(0,1fr))",
                      },
                      gap: 1,
                      py: 1,
                      borderBottom:
                        index <
                        reportBillPassing.length - 1
                          ? "1px dashed #cbd8e6"
                          : "none",
                    }}
                  >
                    {[
                      [
                        "Bill Number",
                        item.billnumber || "N/A",
                      ],
                      [
                        "Receiving Date",
                        formatDate(
                          item.billreceivingdate
                        ) || "N/A",
                      ],
                      [
                        "Passing Date",
                        formatDate(
                          item.billpassingdate
                        ) || "N/A",
                      ],
                    ].map(([label, value], i) => (
                      <Box key={i} sx={{ minWidth: 0 }}>
                        <Typography
                          sx={{
                            color: "#1565c0",
                            fontWeight: 800,
                            fontSize: "0.68rem",
                          }}
                        >
                          {label}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight:
                              label === "Bill Number"
                                ? 800
                                : 600,
                            overflowWrap: "anywhere",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          )}

        {/* =================================================
            CRN DETAILS
        ================================================== */}
        {reportCRN && reportCRN.length > 0 && (
          <Box sx={{ mb: 1.8 }}>
            <Box
              sx={{
                px: 1.4,
                py: 0.9,
                mb: 1,
                borderRadius: 1.8,
                background:
                  "linear-gradient(135deg,#0d47a1,#1976d2)",
                color: "#fff",
                fontWeight: 800,
                fontSize: {
                  xs: "0.76rem",
                  sm: "0.84rem",
                },
              }}
            >
              CRN Details
            </Box>

            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                p: {
                  xs: 0.8,
                  sm: 1.2,
                },
                border: "1px solid #d9e5f2",
                borderRadius: 2,
              }}
            >
              {reportCRN.map((item, index) => (
                <Box
                  key={item.id || index}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, minmax(0,1fr))",
                      md: "repeat(3, minmax(0,1fr))",
                    },
                    gap: 1,
                    py: 1,
                    borderBottom:
                      index < reportCRN.length - 1
                        ? "1px dashed #cbd8e6"
                        : "none",
                  }}
                >
                  {[
                    [
                      "Bill Number",
                      item.billnumber || "N/A",
                    ],
                    [
                      "CRN Number",
                      item.crnnumber || "N/A",
                    ],
                    [
                      "CRN Date",
                      formatDate(item.crndate) ||
                        "N/A",
                    ],
                  ].map(([label, value], i) => (
                    <Box key={i} sx={{ minWidth: 0 }}>
                      <Typography
                        sx={{
                          color: "#1565c0",
                          fontWeight: 800,
                          fontSize: "0.68rem",
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight:
                            label === "Bill Number"
                              ? 800
                              : 600,
                          overflowWrap: "anywhere",
                        }}
                      >
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* =================================================
            PAYMENT DETAILS
        ================================================== */}
        {reportPayment && reportPayment.length > 0 && (
          <Box sx={{ mb: 0.5 }}>
            <Box
              sx={{
                px: 1.4,
                py: 0.9,
                mb: 1,
                borderRadius: 1.8,
                background:
                  "linear-gradient(135deg,#0d47a1,#1976d2)",
                color: "#fff",
                fontWeight: 800,
                fontSize: {
                  xs: "0.76rem",
                  sm: "0.84rem",
                },
              }}
            >
              Payment Details
            </Box>

            <Box
              sx={{
                width: "100%",
                minWidth: 0,
                p: {
                  xs: 0.8,
                  sm: 1.2,
                },
                border: "1px solid #d9e5f2",
                borderRadius: 2,
              }}
            >
              {reportPayment.map((item, index) => (
                <Box
                  key={item.id || index}
                  sx={{
                    py: 1,
                    borderBottom:
                      index < reportPayment.length - 1
                        ? "1px dashed #cbd8e6"
                        : "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0,1fr))",
                        md: "repeat(3, minmax(0,1fr))",
                      },
                      gap: 1,
                    }}
                  >
                    {[
                      [
                        "Bill Number",
                        item.billnumber || "N/A",
                      ],
                      [
                        "CO6 Number",
                        item.co6number || "N/A",
                      ],
                      [
                        "CO6 Date",
                        formatDate(item.co6date) ||
                          "N/A",
                      ],
                      [
                        "CO7 Number",
                        item.co7number || "N/A",
                      ],
                      [
                        "CO7 Date",
                        formatDate(item.co7date) ||
                          "N/A",
                      ],
                      [
                        "Payment Date",
                        formatDate(
                          item.paymentdate
                        ) || "N/A",
                      ],
                    ].map(([label, value], i) => (
                      <Box
                        key={i}
                        sx={{
                          minWidth: 0,
                          p: 0.8,
                          borderRadius: 1.3,
                          background: "#f8fbff",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#1565c0",
                            fontWeight: 800,
                            fontSize: "0.68rem",
                          }}
                        >
                          {label}
                        </Typography>

                        <Typography
                          sx={{
                            mt: 0.2,
                            fontSize: "0.75rem",
                            fontWeight:
                              label === "Bill Number" ||
                              label === "Payment Date"
                                ? 800
                                : 600,
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  </Box>
);
}

export default Reports;
